import type { StripeElementsOptions } from '@stripe/stripe-js'

import { getStripeElementsAppearance } from '~/utils/get-stripe-elements-appearance'
import { getStripeLocale } from '~/utils/get-stripe-locale'

export const getStripeElementsOptions = (
  clientSecret: string,
  language: string,
  isDarkMode: boolean,
): StripeElementsOptions => ({
  appearance: getStripeElementsAppearance(isDarkMode),
  clientSecret,
  locale: getStripeLocale(language),
})
